<template>
  <md-dialog :md-active.sync="isDialogOpen" :md-click-outside-to-close="false">
    <group-card :title="dialogTitle" icon="attach_file">
      <form enctype="multipart/form-data">
        <md-dialog-alert
          :md-active.sync="error.open"
          :md-content="error.message"
          md-title="Failed"
        />
        <div class="md-layout">
          <validated-select-input
            class="md-small-size-10 md-size-10 date-selector"
            label="Billing Year"
            :options="year_list"
            v-model="selected_year"
            v-if="needSelectDate"
          ></validated-select-input>
        
          <validated-select-input
            class="md-small-size-10 md-size-10 date-selector"
            label="Billing Month"
            :options="monthOptions"
            v-model="selected_month"
            :is_sortable="false"
            v-if="needSelectDate"
          ></validated-select-input>

          <md-field>
            <label>{{ dialogText }}</label>
            <md-file
              v-model="fileName"
              @change="selectFile"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              name="file"
              required
            />
          </md-field>
        </div>
        <div>
          <md-button class="md-primary md-simple md-danger" @click="closeDialog">Cancel</md-button>
          <md-button class="md-primary" @click="uploadFile" :disabled="!fileName">Upload</md-button>
          <md-progress-spinner
            :md-diameter="30"
            :md-stroke="3"
            md-mode="indeterminate"
            v-if="loading"
          />
        </div>
      </form>
    </group-card>
  </md-dialog>
</template>

<script>
import { GroupCard } from "@/components";
import AlertDialog from "../AlertDialog.vue";
import ConfirmDialog from "../ConfirmDialog.vue";
import ValidatedSelectInput from "../../ValidatedInput/ValidatedSelectInput.vue";

export default {
  components: {
    GroupCard,
    AlertDialog,
    ConfirmDialog,
    ValidatedSelectInput,
  },
  name: 'SuncorpCsvUploadDialog',
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    dialogTitle: {
      type: String,
      required: true,
    },
    dialogText: {
      type: String,
      required: true,
    },
    needSelectDate: {
      type: Boolean,
      default: false,
    },
    importAction: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isDialogOpen: this.showDialog,
      file: null,
      fileName: null,
      error: {
        open: false,
        message: ''
      },
      loading: false,
      monthOptions: [1,2,3,4,5,6,7,8,9,10,11,12],
      selected_year: new Date().getFullYear(),
      selected_month: new Date().getMonth() + 1,
    }
  },
  watch: {
    showDialog(newValue) {
      this.isDialogOpen = newValue;
    }
  },
  computed: {
    year_list() {
      let current_year = new Date().getFullYear();
      let yearList = [];
      let numberOfPastYears = 10;
      for (let i = 0; i <= numberOfPastYears; i++) {
        yearList.push(current_year - i);
      }
      return yearList;
    },
  },
  methods: {
    selectFile(event) {
      this.file = event.target.files[0];
      this.file_name = this.file.name;
    },
    async uploadFile() {
      this.loading = true;
      // Implement file upload logic here
      // After successful upload, emit the file-uploaded event with the uploaded file
      let payload = {
        'file': this.file,
      }
      if (this.file === null || this.file === undefined) {
        this.$modal.show(AlertDialog, {
          title: "Error",
          message: "Please select CSV file!",
        });
      } else {
        if (this.needSelectDate) {
          if (!(await this.dateConfirmation())) {
            this.loading = false;
            return;
          } else {
            payload = {
              ...payload,
              'billed_at_year': this.selected_year,
              'billed_at_month': this.selected_month,
            }
          }
        }
        this.$emit('file-uploaded', payload, this.importAction);
      }
      this.closeDialog();
    },
    closeDialog() {
      this.file = null;
      this.fileName = null;
      this.error.open = false;
      this.error.message = '';
      this.loading = false;
      this.$emit('close-dialog');
    },
    async dateConfirmation () {
      return this.$modal.show(ConfirmDialog, {
        title: "Date Confirmation",
        message: this.dateConfirmationMessage(),
        confirmText: "Confirm",
        cancelText: "Cancel",
      })
    },
    dateConfirmationMessage () {
      return `
      <p>
      Please ensure Year and Month is correct.<br>
      Year: <span style="color:red">${this.selected_year}</span><br>
      Month: <span style="color:red">${this.selected_month}</span>
      </p>
      `
    },
  }
}
</script>

<style lang="scss" scoped>
.date-selector {
  margin-right: 15px;
  margin-bottom: 10px;
}
</style>